"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isUserLanguagePreferences = exports.UserLanguagePreferencesDefaults = exports.UserLanguagePreferencesSchema = exports.allLearnReasons = void 0;
const zod_1 = require("zod");
const type_validation_helpers_1 = require("../helpers/type_validation_helpers");
const typing_utils_1 = require("../typing_utils");
const fluency_goals_types_1 = require("./fluency_goals_types");
const user_preferences_types_1 = require("./user_preferences_types");
const FluencyGoalCategoriesPreferencesSchema = zod_1.z.object(fluency_goals_types_1.fluencyGoalCategories.reduce((acc, fluencyGoal) => ({ ...acc, [fluencyGoal]: zod_1.z.string().optional() }), {}));
exports.allLearnReasons = [
    "Travel",
    "School",
    "Career",
    "Relocation",
    "Connect",
    "BrainTraining",
    "Other",
];
const LearnReasonSchema = zod_1.z.union(typing_utils_1.mapArrayToLiteralTuple(exports.allLearnReasons));
const PronunciationTargetSchema = zod_1.z.union([
    zod_1.z.literal("soundNative"),
    zod_1.z.literal("understand"),
    zod_1.z.literal("unimportant"),
    zod_1.z.literal("dismissed"),
]);
exports.UserLanguagePreferencesSchema = zod_1.z
    .object({
    dismissableVocabSet: zod_1.z.number(),
    hasDismissedMyFlashcardsWelcomeMessage: zod_1.z.boolean(),
    hideReadingText: zod_1.z.boolean(),
    isMxuBootcampParticipant: zod_1.z.boolean(),
    lastHomeNotificationDate: zod_1.z.string(),
    lastProgressReportSeenDate: zod_1.z.string(),
    lastSeenGuidedLearningChapterCelebration: zod_1.z.number().optional(),
    lastSeenGuidedLearningWeekTransition: zod_1.z.number(),
    lastVocabSetDismissed: zod_1.z.number(),
    learnReasons: LearnReasonSchema.array(),
    pronunciationTarget: PronunciationTargetSchema.optional(),
    readGrammarArticles: zod_1.z.string().array(),
    reviewQualityWarningLastShownAt: zod_1.z.string().optional(),
    userLevel: zod_1.z.nativeEnum(user_preferences_types_1.Level),
    userLevelPronunciation: zod_1.z.nativeEnum(user_preferences_types_1.PronunciationLevel),
})
    .merge(FluencyGoalCategoriesPreferencesSchema);
exports.UserLanguagePreferencesDefaults = {
    dismissableVocabSet: 0,
    hasDismissedMyFlashcardsWelcomeMessage: false,
    hideReadingText: false,
    isMxuBootcampParticipant: false,
    lastHomeNotificationDate: "2020-01-01",
    lastProgressReportSeenDate: "2000-01-01",
    lastSeenGuidedLearningWeekTransition: 1,
    lastVocabSetDismissed: 0,
    learnReasons: [],
    readGrammarArticles: [],
    userLevel: user_preferences_types_1.Level.Unknown,
    userLevelPronunciation: user_preferences_types_1.PronunciationLevel.Beginner,
};
exports.isUserLanguagePreferences = type_validation_helpers_1.getVerboseTypeValidationFunction(exports.UserLanguagePreferencesSchema);
//# sourceMappingURL=language_preferences_types.js.map